import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import {
  syncUserUiPreferencesToLocal,
  fetchUiPreferencesFromServer,
  resolveUiPreferences,
  uiPreferencesToJson,
} from '../config/uiPreferences';

/**
 * After login, load uiPreferences from the server for every user and apply locally.
 */
export default function UiPreferencesBridge() {
  const { user, isAuthenticated, updateUser } = useAuth();
  const lastUserIdRef = useRef(null);

  useEffect(() => {
    if (!isAuthenticated || !user?.id) {
      lastUserIdRef.current = null;
      return;
    }
    if (lastUserIdRef.current === user.id) return;
    lastUserIdRef.current = user.id;

    let cancelled = false;

    (async () => {
      const fromServer = await fetchUiPreferencesFromServer();
      if (cancelled) return;

      const prefs = fromServer ?? resolveUiPreferences(user);
      const json = uiPreferencesToJson(prefs);

      updateUser({ uiPreferences: json });
      syncUserUiPreferencesToLocal({ ...user, uiPreferences: json });
      window.dispatchEvent(new CustomEvent('ui-preferences-applied'));
    })();

    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, user?.id, updateUser]);

  return null;
}
